import { Component, EventEmitter, Input, OnInit, Output, forwardRef} from '@angular/core';
import { IDropdownListItem } from 'src/app/interface/DropDownListItem';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';  //added 12/24/25
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropdownComponent),
            multi: true
        }
    ],
    standalone: true,
    imports: [MatFormFieldModule, NgClass, NgIf, MatSelectModule, NgFor, MatOptionModule, MatIconModule, MatTooltipModule]
})

export class DropdownComponent implements OnInit, ControlValueAccessor {

  @Input() label : string;
  @Input() dropdownList : IDropdownListItem[];
  @Input() val : string;
  @Input() tooltip : string;
  @Input() isWorkerUsername = false;
  @Input() isManageWorkOrderReason = false;
  @Input() isActivity = false;
  @Input() isReason = false;
  @Output() select = new EventEmitter();
  @Input() isAssessment : boolean = false;
  @Input() isRequired : boolean = false;
  @Input() isQueryReport : boolean = false;
  @Input() isQueryReportFormat : boolean = false;
  @Input() isJoinType : boolean = false;
  @Input() disableJoinTypeDropdown : boolean = false;
  @Input() isCrewManagement = false;
  @Input() isRegion = false;
  @Input() disableActivityDropdown = false;
  @Input() disableReasonDropdown = false;
  @Input() id : string = '';  //added 7/15/26 to support setting focus when rendering for accessibility 
  
  public isGeneral = false;
  ngOnInit(){
    if (this.id == '') {
      this.id = 'dropdown-' + Math.random().toString(36).substr(2, 9);
    }
    if ( !(  this.isWorkerUsername || this.isManageWorkOrderReason || this.isReason 
            || this.isAssessment || this.isQueryReport || this.isQueryReportFormat  
            || this.isJoinType || this.isCrewManagement || this.isRegion || this.isActivity) ) {
      this.isGeneral = true;
    } 
  }
  
  //added ControlValueAccessor methods 12/24/25 to avoid error when workerList updated
  writeValue(obj: any): void {}
  registerOnChange(fn: any): void {}
  registerOnTouched(fn: any): void {}

  selectItem(evt) {
    console.log(this.dropdownList);
    this.select.emit(evt.value);
  }
}
